import { Injectable } from '@angular/core';

import { IntegrationsApiService } from '@recruitee/integrations/http';
import { IntegrationKinds } from '@recruitee/integrations/types';

@Injectable({ providedIn: 'root' })
export class AdpApiService extends IntegrationsApiService {
  public context: string = IntegrationKinds.ADP;
}
